export class SetActiveStatusIdsAction {
    public static readonly type = "[Projects] Set active status ids";

    constructor(public payload: string[]) {}
}
